// Team Auberge block
if (document.querySelector('.team-auberge')) {

    const modal = document.querySelector('.auberge-modal');


    const openAubergeModalButton = document.querySelector('.team-auberge .button');

    openAubergeModalButton.addEventListener('click', () => {
        openModal();
    });

    modal.querySelector('.close').addEventListener('click', () => {
        closeModal();
    });

    function openModal() {
        modal.classList.add('open');
        document.body.classList.add('modal-open');
        bodyScrollLock.disableBodyScroll(modal, {
            reserveScrollBarGap: true
        });
    }

    function closeModal() {
        modal.classList.remove('open');
        document.body.classList.remove('modal-open');
        bodyScrollLock.enableBodyScroll(modal);
    }
}

